import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

/** De werksoorten zoals ze in het adres staan: de namen die de lezer ziet, nooit `myxxtract` of `pca`. */
export const WERKSOORTEN = ['vastleggen', 'controles'] as const;
export type Werksoort = (typeof WERKSOORTEN)[number];

/** De zichtbare naam van elke werksoort; dezelfde sleutels als Mijn feedback. */
export const WERKSOORT_LABEL: Record<Werksoort, string> = {
  vastleggen: 'qa.eigen.werksoortMyxxtract',
  controles: 'qa.eigen.werksoortPca',
};

/**
 * De gekozen werksoort leeft in het adres (`?werksoort=controles`), naast de week, zodat een
 * tabwissel, "Bekijk ›" en "terug" dezelfde werksoort houden (CAP-10). Ontbreekt hij of is hij
 * onbekend, dan geldt Vastleggen; het adres blijft dan ongemoeid.
 */
export function useGekozenWerksoort(): { werksoort: Werksoort; kies: (werksoort: Werksoort) => void } {
  const [searchParams, setSearchParams] = useSearchParams();
  const uitAdres = searchParams.get('werksoort');
  const werksoort: Werksoort = uitAdres === 'controles' ? 'controles' : 'vastleggen';

  const kies = useCallback(
    (gekozen: Werksoort) => {
      const volgende = new URLSearchParams(searchParams);
      volgende.set('werksoort', gekozen);
      setSearchParams(volgende);
    },
    [searchParams, setSearchParams],
  );

  return { werksoort, kies };
}
